import { render, staticRenderFns } from "./request-kyc-summary.vue?vue&type=template&id=67168de9&"
import script from "./request-kyc-summary.vue?vue&type=script&lang=js&"
export * from "./request-kyc-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports